import styled from 'styled-components'

const header = styled.div.attrs({
  className: 'mb-4'
})`
`

export default header